module.exports = __webpack_public_path__ + "assets/hotspots_white.6172998d.svg";